<span class="badge" [ngClass]="typeClass()">{{ text() }}</span>
